module.exports = __webpack_public_path__ + "static/centre-banner-4c0b89fa451acff96c4bd7e2e4c9fc69.svg";